import z from 'zod';

const MESSAGE = '* Este campo es obligatorio';

const requiredFieldConfig = {
	required_error: MESSAGE,
	invalid_type_error: MESSAGE,
};

export const adminDialogSchema = z.object({
	id: z.string().optional(),
	name: z.string(requiredFieldConfig),
	email: z.string(requiredFieldConfig).email(),
	roleId: z.string(requiredFieldConfig),
	active: z.boolean().optional(),
});
